var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitroen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2a29",
    d: "M481 304S325 159 256 159c-68 0-229 146-229 146v-40s4-32 26-54S221 62 221 62s33-31 76 1 153 138 153 138 35 32 35 64-4 40-4 40zM35 471s156-145 225-145c68 0 229 146 229 146v-40s-4-32-26-54-168-149-168-149-33-31-76 1S66 368 66 368s-35 32-35 64 4 40 4 40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitroen);
export default __webpack_public_path__ + "static/media/citroen.a0d06d35af9cd8887aa5cf56f2640012.svg";
export { ForwardRef as ReactComponent };